import React from 'react';
import { Box, Chip, ChipProps, Grid, Typography } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';

const useStyles = makeStyles((theme: Theme) => ({
  chip: {
    backgroundColor: theme.palette.background.paper,
    border: '1px solid var(--pill-border-color)',
    borderRadius: theme.spacing(3.125),
    height: theme.spacing(4.75),
    padding: theme.spacing(2.5, 0.5),
    width: theme.spacing(23),
    '&.MuiChip-clickable:hover': {
      background: theme.palette.background.paper,
    },
    '&.MuiChip-clickable:focus': {
      background: theme.palette.background.paper,
    },
  },
  chipWidthAuto: {
    width: 'auto',
  },
}));

type PickedChipProps = Pick<ChipProps, 'onClick' | 'sx'>;

interface Props extends PickedChipProps {
  bold?: boolean;
  endIcon?: React.ReactNode;
  hasElevation?: boolean;
  startIcon?: React.ReactNode;
  title: string;
  widthAuto?: boolean;
  dataTestId?: string;
}

const Pill: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = useStyles();
  const theme = useTheme();

  const {
    bold = false,
    endIcon,
    hasElevation,
    onClick,
    startIcon,
    sx,
    title,
    widthAuto = false,
    dataTestId,
  } = props;

  return (
    <Chip
      className={classNames(classes.chip, {
        [classes.chipWidthAuto]: widthAuto,
      })}
      data-testid={dataTestId}
      clickable
      label={
        <Grid alignItems="center" container>
          {startIcon}
          <Box ml={1}>
            <Typography color="textPrimary" variant="body2">
              {bold ? <Box component="strong">{title}</Box> : title}
            </Typography>
          </Box>
          {endIcon}
        </Grid>
      }
      onClick={onClick}
      style={{ boxShadow: hasElevation ? theme.shadows[4] : undefined }}
      sx={sx}
      variant="outlined"
    />
  );
};

export default Pill;
